var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11879 10.3996C0.845497 10.3996 0.61146 10.3039 0.416677 10.1125C0.222226 9.92077 0.125 9.69043 0.125 9.42145V2.57474C0.125 2.30576 0.222226 2.07558 0.416677 1.88419C0.61146 1.69249 0.845497 1.59663 1.11879 1.59663H1.61568V0.61853H2.60947V1.59663H6.58463V0.61853H7.57842V1.59663H8.07531C8.3486 1.59663 8.58264 1.69249 8.77742 1.88419C8.97187 2.07558 9.0691 2.30576 9.0691 2.57474V5.50904H8.07531V4.53094H1.11879V9.42145H4.59705V10.3996H1.11879ZM9.62811 7.9543L8.57221 6.91507L8.93245 6.5605C9.02355 6.47084 9.13949 6.42601 9.28028 6.42601C9.42107 6.42601 9.53701 6.47084 9.62811 6.5605L9.98835 6.91507C10.0795 7.00472 10.125 7.11884 10.125 7.2574C10.125 7.39597 10.0795 7.51008 9.98835 7.59974L9.62811 7.9543ZM5.59084 10.8886V9.84937L8.22438 7.2574L9.28028 8.29664L6.64674 10.8886H5.59084ZM1.11879 3.55284H8.07531V2.57474H1.11879V3.55284Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCalendar);
export default __webpack_public_path__ + "static/media/edit_calendar.35b1a43293531f68780c62faea61ae18.svg";
export { ForwardRef as ReactComponent };